import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { ClientModel } from '@shared/models/client.model';
import { ClientFilteresResult } from '@shared/models/dvm.model';
import { PaginatedQueryModel } from '@shared/models/paginatedQuery.model';
import { environment } from '@environments/environment';
import { GenericResponse } from '../../../../../shared/interfaces/response.interface';
import { TagAuthModel } from '../../../../../shared/interfaces/tag.interface';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private apiRoot = '/api/clients';
  private readonly apiUrl = environment.apiAuthUrl

  constructor(private http: HttpClient) {}

  public getAll(page: number, name?: string): Observable<PaginatedQueryModel<ClientModel> | Array<ClientModel>> {
    if (!page) page = 1;
    let query = `?page=${page}`;
    if (name) {
      query += `&name=${name}`;
    }
    return this.http.get<PaginatedQueryModel<ClientModel> | Array<ClientModel>>(
      environment.apiAuthUrl + '/api/onelogin/clients' + query
    );
  }
  public listAll(): Observable<PaginatedQueryModel<ClientModel> | Array<ClientModel>> {
    return this.http.get<PaginatedQueryModel<ClientModel> | Array<ClientModel>>(
      environment.apiAuthUrl + this.apiRoot + '/getall'
    );
  }
  public listAllServiceFilterd(serviceName: string): Observable<Array<ClientFilteresResult>> {
    return this.http.get<Array<ClientFilteresResult>>(
      `${environment.apiAuthUrl}${this.apiRoot}/getall/service/${serviceName}`
    );
  }
  public get(clientId: number): Observable<any> {
    return this.http.get<any>(environment.apiAuthUrl + this.apiRoot + `/${clientId}`);
  }
  public getByKey(clientKey: string): Observable<any> {
    return this.http.get<any>(environment.apiAuthUrl + this.apiRoot + `/key/${clientKey}`);
  }
  public getUsersByClient(clientId: number): Observable<any> {
    return this.http.get<any>(environment.apiAuthUrl + `/api/onelogin/clients/${clientId}/users`);
  }
  public create(body: any) {
    return this.http.post<any>(environment.apiAuthUrl + this.apiRoot, body);
  }

  public createIntoContentDistribution(clientKey: string): Observable<any> {
    return this.http.post<any>(`${environment.contentdistribution.private.url}/api/clients`, { key: clientKey });
  }

  public addServiceToClient(clientId: number, serviceName: string): Observable<any> {
    return this.http.post<any>(
      environment.apiAuthUrl + this.apiRoot + `/${clientId}/add/service?service=${serviceName}`,
      null
    );
  }

  public removeServiceFromClient(clientId: number, serviceName: string): Observable<any> {
    return this.http.post<any>(
      environment.apiAuthUrl + this.apiRoot + `/${clientId}/remove/service?service=${serviceName}`,
      null
    );
  }

  public update(clientId: number, body: any): Observable<ClientModel> {
    return this.http.patch<ClientModel>(environment.apiAuthUrl + this.apiRoot + `/${clientId}`, body);
  }

  public delete(clientId: number): Observable<ClientModel> {
    return this.http.delete<any>(environment.apiAuthUrl + this.apiRoot + `/${clientId}`);
  }

  public getClientsByKeys(body: { keys: string[] }) {
    return this.http.post<any>(
      environment.apiAuthUrl + this.apiRoot + '/showmult?fields=name&fields=id&fields=key',
      body
    );
  }
  public getbyname(page: number, name: string) {
    if (!page) page = 1;
    let query = `?page=${page}`;
    if (name) {
      query += `&name=${name}`;
    }
    return this.http.get<PaginatedQueryModel<ClientModel>>(environment.apiAuthUrl + '/api/onelogin/clients' + query);
  }

  public getClientTags(id: number | string) {
    const key = `vw-client-tag-${id}`
    const raw = sessionStorage.getItem(key)
    if (raw !== null) {
      return of(JSON.parse(raw))
    } else {
      return this.http.get<GenericResponse<TagAuthModel>>(this.apiUrl + this.apiRoot + `/${id}/tags`).pipe(
        tap((resp) => {
          sessionStorage.setItem(key, JSON.stringify(resp))
        })
      )
    }
  }

  public addTags(id: number, tags: number[]) {
    return this.http.patch<GenericResponse>(this.apiUrl + this.apiRoot + `/${id}/add/tag`, { tags })
  }
}
